<template>
    <transition name="modal">
              <div class="modal-mask">
                <div class="modal-wrapper">
                  <div class="modal-container" :class="[{ 'loading loading-lg': sending } ]">
                    <button class="modal-close" @click="$emit('close')"></button>

                    <div class="modal-body" v-if="!sending">
                      <slot name="body">
                        default body
                      </slot>
                       
                    </div>
                    <slot name="message"></slot>

                  </div>
                </div>
              </div>
            </transition>
</template>
<script>
import axios from "axios";
export default {
  name: "modal",
  data() {
    return {
      dialog: false,
      sending: false
    }
  },
  mounted(){
    // const storelocator = document.getElementById("store-locator");
    const forms = document.getElementsByClassName("wpcf7-form");
    var form = forms[0];
    if (form.attachEvent) {
      form.attachEvent("submit", this.processForm);
    } else {
      form.addEventListener("submit", this.processForm);
    }
  },
  methods: {
    processForm(e) {
      this.sending=true;
      if (e.preventDefault) e.preventDefault();
      let data = new FormData(e.target);
      let url = window.VSTOptions.ajaxurl;
        
      data.append('id', data.get("_wpcf7"));
      data.append('action', window.VSTOptions.send); 
      data.append('nonce', window.VSTOptions.nonce);

      const send = axios.post(url, data);
      send.then((value) => { 
        this.$emit("update", {
          status: value.data.status,
          message: value.data.message
        });
        this.sending = false;
        
      })
        .catch((err) => {
          console.error(err);
          this.sending = false;
        });


    }
  }
}
</script>